import React from 'react';
import { cn } from '../../../utils/cn';

const DeviceGrid = ({ 
  children,
  columns = 'auto',
  gap = 'base',
  variant = 'default',
  className,
  ...props 
}) => {
  const gaps = {
    sm: 'gap-3',
    base: 'gap-5',
    lg: 'gap-6'
  };

  const columnSizes = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4',
    auto: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5'
  };

  const variants = {
    default: '',
    compact: 'max-w-none',
    centered: 'max-w-7xl mx-auto'
  };

  return (
    <div
      className={cn(
        'grid',
        columnSizes[columns] || columnSizes.auto,
        gaps[gap],
        variants[variant],
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default DeviceGrid;